import { prevArrowMarkup, nextArrowMarkup } from './icons/arrowMarkup'

const SLIDE_CLASS = 'swiper-slide'

function applySwiperTheme(element, theme) {
  if (!element) return
  element.classList.remove('black', 'white')
  element.classList.add(theme)
}

/**
 * Wrap legacy markup (.slider-container, .quotes-widget-slider) into Swiper structure.
 */
export function prepareSwiperDom(container, {
  paginationContainer,
  navigationSelector,
  theme = 'black',
  skipNavigation = false,
  skipPagination = false,
} = {}) {
  if (!container) return null

  if (container.swiper) {
    return container
  }

  container.classList.add('swiper', 'adagio-swiper')
  applySwiperTheme(container, theme)

  let wrapper = container.querySelector(':scope > .swiper-wrapper')
  if (!wrapper) {
    wrapper = document.createElement('div')
    wrapper.classList.add('swiper-wrapper')

    const children = [...container.children].filter(
      (node) => !node.classList.contains('swiper-button-prev')
        && !node.classList.contains('swiper-button-next'),
    )

    children.forEach((child) => {
      child.classList.add(SLIDE_CLASS)
      wrapper.appendChild(child)
    })

    container.prepend(wrapper)
  }

  // Clean up any old navigation rendered inside .swiper.
  container.querySelectorAll('.swiper-button-prev, .swiper-button-next').forEach((el) => el.remove())

  const prevElements = []
  const nextElements = []

  if (!skipNavigation) {
    const outsideNavRoot = container.parentElement ?? container
    let navContainers = outsideNavRoot.querySelectorAll(`:scope ${navigationSelector}`)
    if (!navContainers.length) {
      navContainers = [document.createElement('div')]
      navContainers[0].classList.add(navigationSelector.replace('.', ''))
      outsideNavRoot.appendChild(navContainers[0])
    }

    navContainers.forEach((navContainer) => {
      applySwiperTheme(navContainer, theme);

      let prevEl = navContainer.querySelector('.swiper-button-prev')
      if (!prevEl) {
        const prevWrap = document.createElement('div')
        prevWrap.innerHTML = prevArrowMarkup
        prevEl = prevWrap.firstElementChild
        prevEl.classList.add('swiper-button-prev')
        navContainer.appendChild(prevEl)
      }
  
      let nextEl = navContainer.querySelector('.swiper-button-next')
      if (!nextEl) {
        const nextWrap = document.createElement('div')
        nextWrap.innerHTML = nextArrowMarkup
        nextEl = nextWrap.firstElementChild
        nextEl.classList.add('swiper-button-next')
        navContainer.appendChild(nextEl)
      }

      prevElements.push(prevEl)
      nextElements.push(nextEl)
    })
  }

  let paginationEl = null

  if (!skipPagination) {
    const outsideRoot = container.parentElement ?? container
    const resolvedPaginationContainer = paginationContainer || (() => {
      let created = outsideRoot.querySelector(':scope > .adagio-swiper-pagination')
      if (!created) {
        created = document.createElement('div')
        created.classList.add('adagio-swiper-pagination')
        outsideRoot.appendChild(created)
      }
      return created
    })()

    paginationEl = resolvedPaginationContainer.querySelector('.swiper-pagination')
    if (!paginationEl) {
      paginationEl = document.createElement('div')
      paginationEl.classList.add('swiper-pagination')
      resolvedPaginationContainer.appendChild(paginationEl)
    }
    resolvedPaginationContainer.classList.add('adagio-swiper-pagination')
    applySwiperTheme(resolvedPaginationContainer, theme)
  }

  return { container, paginationEl, prevElements, nextElements }
}

export function resolveSliderRoot(root, containerSelector) {
  if (!root) return null
  if (root.matches?.(containerSelector)) return root
  return root.querySelector?.(containerSelector) ?? null
}
